export default {"src":"/_next/static/media/google-ic.fa8b88b2.svg","height":48,"width":48};